import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EnvironmentLabelComponent } from './environment-label/environment-label.component';
import { IconsModule } from '@platform-frontend/ui-tools';

@NgModule({
  declarations: [EnvironmentLabelComponent],
  imports: [CommonModule, RouterModule, IconsModule],
  exports: [EnvironmentLabelComponent]
})
export class EnvironmentLabelModule {}
